import axios from "axios";
import { createContext, useState, } from "react";
import { useCookies } from "react-cookie";
import { useNavigate, useLocation } from "react-router-dom";
// import { TostMessageContext } from "./TostMessage";
import { base_url } from '../url_variables';

export const UserContext = createContext();
// 12345678@Abc
export function UserProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userProfile, setUserProfile] = useState({});
  // const { setTostMessage } = useContext(TostMessageContext);
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  // const location = useLocation();

  function logOutFunction() {
    setUserProfile({});
    removeCookie("userProfile", { path: "/" });
    navigate('/');
  }

  async function reloadUser() {
    console.log('reloading')
    const date = new Date();
    let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours
    try {
      const response = await axios.get(base_url + '/auth/reload_user.php', {
          headers: {
              "Content-Type": "multipart/form-data",
              token: cookies?.userProfile?.session,
              main_id: cookies?.userProfile?.main_id,
              sub_id: cookies?.userProfile?.sub_id
          },
      });
      if (response.data.code == 403) {
          logOutFunction()
      }
      if (response.data.status) {
          const user_details = {...response.data.user, sub_id: response.data.user?.child_array[0]?.id, sub_name: response.data.user?.child_array[0]?.name, account_type: 'main', attendance: response.data.user?.child_array[0]?.attendance}
          setCookie("userProfile", user_details, {
              path: "/",
              maxAge: expiresDate,
              secure: true,
          });
          setUserProfile(user_details);
      } else {

      }
    } catch (error) {
      
    }
  }

  return (
    <UserContext.Provider
      value={{
        logOutFunction,
        isLoggedIn,
        isLoading,
        setIsLoading,
        userProfile,
        setUserProfile,
        reloadUser
        // getUserProfileFunction,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}
